import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-regular-svg-icons";
import { ConditionIcon } from "../../../../components";
import { ImageLetters } from "..";
import { getImageAndVideoFileTypes, round2 } from "../../../../util/common";

import "./index.scss";

class FixedCheckItems extends Component {
  renderRow = (item, id, description, price, status) => {
    const { images } = getImageAndVideoFileTypes(item.attachments);

    return (
      <Grid.Row key={id} className={"fixed-checks-row"}>
        <Grid.Column width={14}>
          {item.title && (
            <span className="fixed-checks-title">
              <ConditionIcon status={status} small />
              {images?.length > 0 && (
                <>
                  <ImageLetters images={images} lettersMap={this.props.lettersMap} />
                  &nbsp;&nbsp;
                </>
              )}
              {item.title}
            </span>
          )}

          {description && (
            <div className="fixed-checks-profile-desc-container">
              <span className="fixed-checks-description">{description}</span>
            </div>
          )}
        </Grid.Column>
        <Grid.Column width={2}>{price}</Grid.Column>
      </Grid.Row>
    );
  };

  renderPrice = price => {
    const { include_vat, vat } = this.props.settings;

    if (!(price > 0.01)) return null;

    if (include_vat) price = price * (1 + vat / 100);

    return <span className="fixed-checks-price">€ {round2(price).toFixed(2)}</span>;
  };

  renderFixedItems = interventions => {
    if (!Array.isArray(interventions)) return null;

    return interventions.map(i => this.renderRow(i, i.id, i.description, this.renderPrice(i.price), i.question_result_status));
  };

  render() {
    let { fixedItems, t } = this.props;

    if (fixedItems.length < 1) return null;

    return (
      <Grid className="report-v2-fixed-checks-container component-checks-container component-container">
        <Grid.Row className="fixed-checks-heading">
          <Grid.Column width={16}>
            <div className="fixed-checks-heading-title-container">
              <FontAwesomeIcon icon={faCog} className="fixed-checks-heading-icon" />
              <h2 className="fixed-checks-heading-title">{t("cc_items_fixed").message || "Items fixed"}</h2>
            </div>
          </Grid.Column>
          <Grid.Column width={16}>
            <div className="fixed-checks-heading-subtitle-container">
              <h3>{t("cc_fixed_checks_heading_explainer").message || "The items below have been carried out."}</h3>
            </div>
          </Grid.Column>
        </Grid.Row>

        {this.renderFixedItems(fixedItems)}
      </Grid>
    );
  }
}

const TranslatedFixedCheckItems = withTranslation()(FixedCheckItems);

TranslatedFixedCheckItems.filterFixedItems = results => {
  return results.filter(r => r.mechanic_fixed);
};

export default TranslatedFixedCheckItems;
